import React, { useState } from "react";
import { toast } from "react-toastify";

import copy from "../../../assets/icons/copy.svg";
import gatewayLogo from "../../../assets/icons/gatewayLogosvg.svg";
import update from "../../../assets/icons/update-pin.svg";
import { useUpdateGatewayPin } from "../../../lib/queries/queriesAndMutations";
import { api } from "../../../utils/axios/Config";
import Switch from "../../shared/Checkbox/Switch";
import AlertButton from "../../ui/AlertButton";

const GatewayCard = ({ rowData, index, isApproved, refetch }) => {
  const { mutateAsync: updatePin } = useUpdateGatewayPin();
  const { gateway } = rowData;

  const handleUpdatePin = async () => {
    try {
      const response = await updatePin(gateway.id);
      if (response.status === 200) {
        toast.success("پین با موفقیت تغییر یافت");
        refetch();
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div className="bg-primary-20 p-4 rounded-[16px] flex flex-col gap-2 md:gap-4  items-center shadow-lg border  ">
      <div className="flex justify-between items-center w-full">
        <div className=" flex-center items-top gap-2  text-dark  ">
          <img
            src={gatewayLogo}
            width={28}
            height={28}
            alt=""
            className="white-img rounded-lg min-w-[32px] min-h-[32px] max-w-[32px] max-h-[32px]  "
          />
          <p className="max-w-[200px] truncate text-[22px]  font-semibold">{gateway?.website_fa}</p>
        </div>

        <p className="max-w-[200px] truncate text-[22px]  font-semibold">{gateway?.website_en}</p>
      </div>

      <div className="mt-4  flex flex-col gap-1 items-center w-full">
        <div className="flex flex-col text-dark gap-4  w-full rounded-[16px] text-title-sm-regular">
          <div className="flex justify-between items-center gap-2 w-full">
            <label className="text-[12px]" htmlFor="">
              حوزه فعالیت
            </label>

            <p>{gateway.field}</p>
          </div>

          <div className="flex justify-between items-center gap-2 w-full">
            <label className="text-[12px]" htmlFor="">
              دامنه سایت
            </label>
            {gateway?.domain}
          </div>
          <div className="flex justify-between items-center gap-2 w-full">
            <p className="text-[12px]"> پین:</p>
            <p dir="ltr" className="max-w-[150px] truncate shadow-sm">
              {gateway.pin}
            </p>
          </div>
        </div>
      </div>
      <div className="flex gap-2 mt-auto flex-col w-full ">
        <div className="flex justify-between items-center gap-2 w-full">
          <label className="text-[12px]" htmlFor="">
            وضعیت درگاه
          </label>
          <ActivegatewayCheckbox gateway={gateway} refetch={refetch} />
        </div>

        <div className="flex justify-between items-center w-full ">
          <FormStateCard status={gateway.approval_status} active={gateway.active} />
          <div className="flex gap-1">
            <div className="flex gap-2">
              <AlertButton
                onClick={() => handleUpdatePin()}
                className="hover:bg-[#CED3D9]   my-auto flex gap-2 p-2 border rounded-lg  items-center"
                refetch={refetch}
              >
                <img className="" width={20} height={20} src={update} alt="update" />
              </AlertButton>
            </div>
            <CopyButton copyText={`${gateway?.pin}` ?? "-"} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GatewayCard;

const ActivegatewayCheckbox = ({ gateway, refetch }) => {
  const [active, setActive] = useState(gateway?.active);
  const hadnleActiveForm = async () => {
    try {
      const response = await api.patch(`/gateways/update/active/${gateway?.id}/`, {
        active_status: !gateway.active,
      });

      if (response.status === 200) {
        toast.success(active ? "درگاه غیرفعال گردید" : "درگاه فعال گردید");
        setActive(!active);
        refetch();
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <div className="relative  flex ">
      <Switch value={active} onChange={() => hadnleActiveForm()} disabled={false} />
    </div>
  );
};

const CopyButton = ({ copyText }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const handleCopy = (e) => {
    e.stopPropagation();
    navigator.clipboard.writeText(copyText);

    setShowTooltip(true);
    setTimeout(() => setShowTooltip(false), 1500); // Tooltip shows for 1.5 seconds
  };

  return (
    <div className="relative   flex ">
      <button
        title="کپی"
        onClick={(e) => handleCopy(e)}
        className=" hover:bg-[#CED3D9]   my-auto flex gap-2 p-2 border rounded-lg  items-center"
      >
        <p>کپی کردن پین</p>
        <img src={copy} alt="" width={20} height={20} style={{ minWidth: "16px", minHeight: "16px" }} />
      </button>
      {showTooltip && (
        <div className="absolute   left-1/2 transform -translate-x-1/2 mb-2 bg-gray-800 text-white text-xs px-2 py-1 rounded">
          کپی{`\u202F`}شد
        </div>
      )}
    </div>
  );
};

const FormStateCard = ({ status, active }) => {
  if (!active) {
    return (
      <div className=" px-[10px] py-1 rounded-md text-error-90 bg-error-10 text-title-sm-regular">
        موقتا غیرفعال
      </div>
    );
  }
  const statesArray = [
    {
      state: "pending",
      text: "در انتظار تایید",
      className: "text-[#CC8F14] bg-[#FFF0D1] px-[10px] py-1 rounded-md  text-title-sm-regular",
    },
    {
      state: "approved",
      text: "تایید شده",
      className: " px-[10px] py-1 rounded-md text-success-60 bg-success-10 text-title-sm-regular",
    },
    {
      state: "denied",
      text: "رد شده",
      className: "text-error-90 bg-error-20 px-[10px] py-1 rounded-md  text-title-sm-regular",
    },
  ];

  const activeItem = statesArray.find((item) => item.state === status);

  return <div className={activeItem?.className}>{activeItem?.text}</div>;
};
